import React from "react";
import { profile, navLinks } from "../../mock";

const Footer = () => {
  const year = new Date().getFullYear();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer className="px-6 md:px-10 pt-16 pb-10 border-t border-[#E8E0D3] bg-[#FAF7F2]">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="font-serif text-3xl md:text-4xl text-[#1F1B16] leading-tight max-w-md">
              Quality is a{" "}
              <span className="italic text-[#8a5a3d]">mindset</span>, not a phase.
            </div>
            <p className="mt-4 text-[#6B5F52] text-sm max-w-md">
              Built with care, served warm. Designed and coded by {profile.firstName}.
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#8a7d6e] mb-4">
              Navigate
            </div>
            <ul className="space-y-2">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => scrollTo(l.id)}
                    className="text-[#3a342d] hover:text-[#B8542B] text-sm transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#8a7d6e] mb-4">
              Elsewhere
            </div>
            <ul className="space-y-2">
              <li>
                <a
                  href={profile.socials.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#3a342d] hover:text-[#B8542B] text-sm transition-colors"
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  href={profile.socials.github}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#3a342d] hover:text-[#B8542B] text-sm transition-colors"
                >
                  GitHub
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${profile.email}`}
                  className="text-[#3a342d] hover:text-[#B8542B] text-sm transition-colors"
                >
                  Email
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#E8E0D3] flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
          <div className="font-mono text-[11px] text-[#8a7d6e]">
            © {year} {profile.name}. All rights reserved.
          </div>
          <div className="font-mono text-[11px] text-[#8a7d6e]">
            Crafted in Bengaluru · Set in Fraunces & Inter
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
